import { Availability, MenuItem, MenuItemUpsert, WorkDay } from '@core/models';
import { JuvoTrackSession } from '@core/domain/local-channel';
import { CartCalculationInput } from './cart-calculation.interface';

export interface CartStockRefreshEffectInput {
	action: { menuId?: string };
	cartItems: MenuItem[];
	localChannelId: string | null;
}

export interface CartStockRefreshContext {
	cartItems: MenuItem[];
	localChannelId: string | null;
	menuId: string | null;
	articleIds: string[];
}

export interface CartItemUpsertEffectInput {
	action: { item: MenuItem };
	cartItems: MenuItem[] | null;
	storeSlug: string;
}

export interface CartItemUpsertContext {
	cartItems: MenuItem[] | null;
	item: MenuItem;
	storeSlug: string;
	mergedCartItems: MenuItem[];
	positiveQuantityCartItems: MenuItem[];
	updatedCartItems: MenuItem[];
}

export interface CartStockUpdateEffectInput {
	action: { updateProduct: MenuItemUpsert };
	productList: MenuItem[] | null;
	cartItems: MenuItem[] | null;
}

export interface CartStockUpdateContext {
	updateProduct: MenuItemUpsert;
	productList: MenuItem[] | null;
	cartItems: MenuItem[] | null;
	updatedProductList: MenuItem[];
	availableProductList: MenuItem[];
	stockAdjustedCartItems: MenuItem[];
	quantityLimitedCartItems: MenuItem[];
	positiveQuantityCartItems: MenuItem[];
	synchronizedCartItems: MenuItem[];
	updatedCartItems: MenuItem[];
}

export interface CartItemAvailabilityContext {
	cartItems: MenuItem[];
	availabilityList: Availability[] | null;
	localChannelSession: JuvoTrackSession | null;
	now?: Date;
	unavailableItems: MenuItem[];
}

export interface CartItemRemovalContext {
	cartItems: MenuItem[] | null;
	idCartItem: string;
	shouldRemove: boolean;
	updatedCartItems: MenuItem[];
}

export interface CartTotalsEffectInput {
	cartItems: MenuItem[] | null;
	tipDetail: CartCalculationInput['tipDetail'];
	workDay: WorkDay | null;
	deliveryZone: CartCalculationInput['deliveryZone'];
	orderType: CartCalculationInput['orderType'];
	coupon: CartCalculationInput['coupon'];
	localChannelSession: JuvoTrackSession | null;
}

export interface CartTotalsPreparationContext {
	cartItems: MenuItem[] | null;
	tipDetail: CartCalculationInput['tipDetail'];
	workDay: WorkDay | null;
	deliveryZone: CartCalculationInput['deliveryZone'];
	orderType: CartCalculationInput['orderType'];
	coupon: CartCalculationInput['coupon'];
	localChannelSession: JuvoTrackSession | null;
	isValid: boolean;
	eligibleCartItems: MenuItem[];
	cartItemsWithSubtotalPrice: MenuItem[];
}

export type CartItemUpsertRule = (context: CartItemUpsertContext) => CartItemUpsertContext;
export type CartStockUpdateRule = (context: CartStockUpdateContext) => CartStockUpdateContext;
export type CartItemAvailabilityRule = (
	context: CartItemAvailabilityContext
) => CartItemAvailabilityContext;
export type CartTotalsPreparationRule = (context: CartTotalsPreparationContext) => CartTotalsPreparationContext;

export type ValidCartTotalsPreparationContext = CartTotalsPreparationContext & {
	cartItems: MenuItem[];
	workDay: WorkDay;
	isValid: true;
};
